export default [
    {
        TGW:{
            TGW1O :{
                Desc:"Some string paragraph 1111111",
                specs:{
                       
                       Motor:"BLDC of 600 watts, 48 V, 500rpm",
                       Frame:"AISI 4130 & AISI 1018",
                       weight:"90.22 kg",
                       length:"80.72 in",
                       width:"57.02 in",
                       Wheelconfig:"Front-2 Rear-1",
                       Suspension:"Helical Spring",
                       Steering:"Links and Lock Mechanism",
                       Brakes:"Front & Rear-Disc Brakes",
                       Suspension:"Wishbone",
                       

                      },
                
            },
            TGW90 :{
                Desc:"Some string paragraph 1111111",
                specs:{
                       
                       Motor:"BLDC of 600 watts, 48 V, 500rpm",
                       Frame:"AISI 4130 & AISI 1018",
                       weight:"102.37 kg",
                       length:"84.13 in",
                       Height:"66.85 in",
                       width:"58.11 in",
                       Wheelconfig:"Front-2 Rear-1",
                       Suspension:"Helical Spring",
                       Steering:"Bell Crank Mechanism",
                       Brakes:"Front & Rear-Disc Brakes",
                       
                       

                      },

            }
           
          }
    }

]